module.exports = __webpack_public_path__ + "img/my-coupon-icon.7dc046d9.png";